import React, { useState, useEffect } from 'react';
import { Minus, X } from 'lucide-react';
import Logo from './Logo';

const TitleBar = () => {
    const [isElectron, setIsElectron] = useState(false);

    useEffect(() => {
        if (window.navigator.userAgent.includes('Electron')) {
            setIsElectron(true);
        }
    }, []);

    const handleMinimize = () => {
        if (window.electronAPI) {
            window.electronAPI.minimize();
        }
    };

    const handleClose = () => {
        if (window.electronAPI) {
            window.electronAPI.close();
        }
    };

    if (!isElectron) return null;

    return (
        <div style={{ WebkitAppRegion: 'drag' }} className="w-full h-8 flex justify-between items-center fixed top-0 left-0 z-[9999] pointer-events-auto bg-black/40 backdrop-blur-sm border-b border-white/5">
            <div className="flex items-center gap-2 pl-3 h-full">
                <Logo className="w-4 h-4" />
                <span className="text-[10px] uppercase tracking-widest font-bold text-white/50">Gemule Trainer</span>
            </div>
            <div style={{ WebkitAppRegion: 'no-drag' }} className="flex h-full">
                <button 
                    onClick={handleMinimize}
                    className="h-full px-4 text-white/50 hover:bg-white/10 hover:text-white transition-colors flex items-center justify-center focus:outline-none"
                    aria-label="Minimize"
                >
                    <Minus className="w-4 h-4" />
                </button>
                <button 
                    onClick={handleClose}
                    className="h-full px-4 text-white/50 hover:bg-red-500 hover:text-white transition-colors flex items-center justify-center focus:outline-none"
                    aria-label="Close"
                >
                    <X className="w-4 h-4" />
                </button>
            </div>
        </div>
    );
};

export default TitleBar;
